import Vue from "vue";
import axios from "axios";

let otaBaseUrl = `${process.env.VUE_APP_CONFIG_OTA_BASEURL}`;
let token = `${process.env.VUE_APP_CONFIG_OTA_TOKEN}`;
let otaConfig = {
    baseURL: otaBaseUrl,
    headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
        "X-User-Token": token,
    },
    //withCredentials: true,
};
const axiosClient = axios.create(otaConfig);

const otaDashboardService = {

    async getUserCheck() {
        let url = `/user/check`;
        return axiosClient.post(url);
    },
    async getUsersList(data) {
        let url = `users/list`;
        return axiosClient.post(url, data);
    },
    async createToken(data) {
        let url = `users/token_create`;
        return axiosClient.post(url, data);
    },
    async revokeToken(data) {
        let url = `users/token_revoke`;
        return axiosClient.post(url, data);
    },
    async modifyUser(data) {
        let url = `users/modify`;
        return axiosClient.post(url, data);
    },
    async createNewUser(data) {
        let url = `users/add`;
        return axiosClient.post(url, data);
    },
    async saveCarrier(data) {
        let url = `carriers/modify`;
        return axiosClient.post(url, data);
    },
    async getCarrierFileInfo(data) {
        let url = `files/info`;
        return axiosClient.post(url, data);
    },
    async downloadCarrierFile(data) {
        let url = `files/download`;
        return axiosClient.post(url, data);
    },
    async disableCarrierFile(data) {
        let url = `files/disable`;
        return axiosClient.post(url, data);
    },
    async disableCarrier(data) {
        let url = `carriers/disable`;
        return axiosClient.post(url, data);
    },
    async removeCarrier(data) {
        let url = `carriers/remove`;
        return axiosClient.post(url, data);
    },
    async addCarrier(data) {
        let url = `/carriers/add`;
        return axiosClient.post(url, data);
    },
    async getCarriers(data) {
        if (!data || data==='') data = { add:1,files:1};
        let url = `carriers/list`;
        return axiosClient.post(url, data);
    },
    async getCarriersList(data) {  //same as getCarriers
        if (!data || data==='') data = { add:1,files:1};
        let url = `carriers/list`;
        return axiosClient.post(url, data);
    },
    async inventory(data) {
        let url = `inventory/list`;
        return axiosClient.post(url, data);
    },
    async activate(data) {
        let url = `ota/activate`;
        return axiosClient.post(url, data);
    },

    async activate_simple(iccid, msisdn, mdn, min, eprl, oplmn, fplmn, smsota, force = 0) {
        //TODO: remap this one.
        let url = `ota/activate`;
        let data = {
            type: "ota",
            method: "activate",
            force: force,
            iccid: iccid
        };
        if (msisdn && String(msisdn).length > 1) data.msisdn = msisdn;
        if (mdn && String(mdn).length > 1) data.mdn = mdn;
        if (min && String(min).length > 1) data.min = min;
        if (eprl && String(eprl).length > 1) data.eprl = eprl;
        if (oplmn && String(oplmn).length > 1) data.oplmn = oplmn;
        if (fplmn && String(fplmn).length > 1) data.fplmn = fplmn;
        if (smsota && String(oplmn).length > 1) data.smsota = smsota;
        return axiosClient.post(url, data);
    },

    async query(iccid, log, minimal) {
        if (!log || log === "undefined") log = 0;
        if (!minimal || minimal === "undefined" || minimal < 1) {
            let url = `ota/query`;
            let data = {
                type: "ota",
                method: "query",
                log_from: log,
                iccid: iccid
            };
            return axiosClient.post(url, data);
        } else {
            return this.query_minimal(iccid);
        }
    },

    async query_minimal(iccid) {
        let url = `ota/query_minimal`;
        let data = {iccid: iccid};
        return axiosClient.post(url, data);
    },

    async exists(iccid) {
        let url = `ota/exists`;
        let data = {iccid: iccid};
        return axiosClient.post(url, data);
    },

    async reset(iccid) {
        let url = `ota/reset`;
        let data = {iccid: iccid};
        return axiosClient.post(url, data);
    },

    async enable(iccid) {
        let url = `ota/enable`;
        let data = {iccid: iccid};
        return axiosClient.post(url, data);
    },

    async disable(iccid, reason) {
        let url = `ota/disable`;
        let data = {iccid: iccid, reason: reason};
        return axiosClient.post(url, data);
    },

    async trigger(iccid) {
        let url = `ota/trigger`;
        let data = {iccid: iccid};
        return axiosClient.post(url, data);
    },

    async transfer(from, to, reason) {
        let url = `ota/transfer`;
        let data = {
            from: from,
            to: to,
            reason: reason
        };
        return axiosClient.post(url, data);
    },

    async reissue(filter) {
        let data = {filter: filter};
        let url = `ota/reissue`;
        return axiosClient.post(url, data);
    },

    async removeUser(payload) {
        let url = 'users/remove';
        return axiosClient.post(url, payload)
    },

    async disableUser(payload) {
        let url = 'users/disable';
        return axiosClient.post(url, payload)
    }
};

export default otaDashboardService;
